import { render, staticRenderFns } from "./SettingEmails.vue?vue&type=template&id=581b644e&scoped=true&"
import script from "./SettingEmails.vue?vue&type=script&lang=js&"
export * from "./SettingEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581b644e",
  null
  
)

export default component.exports